import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Cell } from "../../../../../backend/backendapi";

@Component({
    name: 'MiscTab',
    components: {
    },
})
export default class MiscTab extends Vue {
    @Prop({ required: true })
    readonly cell!: Cell | undefined;

    readonly predefinedColors = [
        {color:'#ffffff', name: 'white'}, //white
        {color:'#ffff00', name: 'yellow'}, //yellow
        {color:'#ff00ff', name: 'fuchsia'}, //fuchsia
        {color:'#ff0000', name: 'red'}, //red
        {color:'#c0c0c0', name: 'silver'}, //silver
        {color:'#808080', name: 'gray'}, //gray
        {color:'#808000', name: 'olive'}, //olive
        {color:'#800080', name: 'purple'}, //purple
        {color:'#800000', name: 'maroon'}, //maroon
        {color:'#00ffff', name: 'aqua'}, //aqua
        {color:'#00ff00', name: 'lime'}, //lime
        {color:'#008080', name: 'teal'}, //teal
        {color:'#008000', name: 'green'}, //green
        {color:'#0000ff', name: 'blue'}, //blue
        {color:'#000080', name: 'navi'}, //navi
        {color:'#000000', name: 'black'}, //black
    ];


    //computed baselinehours
    private get baseLineHours() {
        let hours = 0;
        hours = this.cell?.baseLineMinutes ?? 0;
        hours /= 60;
        return hours;
    }
    private set baseLineHours(val: number) {
        if (this.cell) {
            if (val < 0) {
                this.cell.baseLineMinutes = val;
                this.$nextTick(() => {
                    if (this.cell) this.cell.baseLineMinutes = 0;
                });
                return;
            }
            this.cell.baseLineMinutes = val * 60;
        }
    }
}